import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AuditRunOwnerFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.AUDIT_RUN_OWNER}
        filterName={FilterName.AUDIT_RUN_OWNER}
        valueKey="auditRunOwners"
        isNested={isNested}
      />
    )
  },
)
